'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["detached"],
  _excluded2 = ["className", "detached", "size"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { MODAL_CLOSE_BUTTON_OFFSET } from 'HubStyleTokens/sizes';
import { rgba } from '../core/Color';
import HoverProvider from '../providers/HoverProvider';
import { MONOLITH, OLAF } from 'HubStyleTokens/colors';
import UICloseButton from '../button/UICloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
const getOffset = css(["right:40px;top:40px;"]);
const getDetachedStyle = (hovered, size) => css(["@media only screen and (min-width:50em){color:", ";position:absolute;", ";&::after{background:", ";}}"], hovered && MONOLITH, size === 'xl' && getOffset, rgba(OLAF, 0.1));
const CloseButton = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UICloseButton, Object.assign({}, rest));
}).withConfig({
  displayName: "UIDialogCloseButton__CloseButton",
  componentId: "qwseax-0"
})(["top:", ";", ";"], MODAL_CLOSE_BUTTON_OFFSET, props => props.detached && getDetachedStyle(props.hovered, props.size));
export default function UIDialogCloseButton(props) {
  const {
      className,
      detached,
      size
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  const computedSize = detached && size == null ? 'xl' : size;
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, props, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(CloseButton, Object.assign({
      className: classNames("uiDialog-closeButton private-modal__control private-modal__close", className)
    }, rest, hoverProviderProps, {
      detached: detached,
      size: computedSize
    }))
  }));
}
UIDialogCloseButton.propTypes = {
  detached: PropTypes.bool.isRequired,
  size: UICloseButton.propTypes.size
};
UIDialogCloseButton.defaultProps = {
  detached: false
};
UIDialogCloseButton.displayName = 'UIDialogCloseButton';